import type { Message } from '../types/interfaces'
import { MessageSourceType, MessageType } from '../types/enums'

/**
 * Los mensajes de sistema —transferencias, "se unio a la conversacion", avisos de
 * inactividad— viven en el mismo array que la conversacion pero no son parte de
 * ella: no son el "ultimo mensaje" del chat ni deciden si el cliente espera
 * respuesta. Llegan con source_type INTERACTION, que el normalizador del front
 * convierte en SALIENTE, asi que hay que mirar tambien el tipo de contenido.
 */
export const isVisibleMessage = (message: Message) =>
  (message.source_type === MessageSourceType.ENTRANTE ||
    message.source_type === MessageSourceType.SALIENTE ||
    message.source_type === MessageSourceType.TEMPLATE) &&
  message.content?.type !== MessageType.INTERACTION

export const getLastVisibleMessage = (messages?: Message[]) => {
  if (!messages) return undefined

  for (let index = messages.length - 1; index >= 0; index--) {
    if (isVisibleMessage(messages[index])) return messages[index]
  }

  return undefined
}

/** El chat espera respuesta del agente: lo ultimo que se dijo lo dijo el cliente. */
export const isAwaitingAgentReply = (messages?: Message[]) =>
  getLastVisibleMessage(messages)?.source_type === MessageSourceType.ENTRANTE
